import * as React from 'react'
import * as styles from '../style/index.scss'
import {filterFlowUnit, formatDate} from '@src/utils';
import {FormattedMessage} from 'react-intl'
import intl from '@utils/intl';

export default ({type, dto}) => (
    <section className={styles.dataPlanItemWrap}>
        <div className={styles.packageName} style={{backgroundColor: type === '0' ? '#1B334C' : '#9B9B9B'}}>
            {dto.goodsReleaseName}
        </div>
        <div className={styles.packageInfo}>
            <p>{filterFlowUnit(dto.goodsNumber * Number(dto.policyDegree))}</p>
            {
                dto.timeUnit === '0' && <span>{filterFlowUnit(dto.policyDegree)}/{intl.formatMessage({id: dto.timeUnit === '0' ? 'common.unitMonthOdd' : 'common.unitDayOdd'})}</span>
            }
            {
                dto.startDate ?
                    <span>{`${formatDate(dto.startDate)} - ${formatDate(dto.endDate)} UTC`}</span>
                    :
                    <span>
                        <FormattedMessage
                            id="package.validTo"
                            values={{
                                date: formatDate(dto.effectiveEndDate)
                            }}
                        />
                    </span>
            }
        </div>
    </section>
)
